import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { FileTextOutlined } from "@ant-design/icons";
import { setEbullTab } from "../../state/slices/generalSlice";

import TabBody from "../../components/SelectContent/TabBody";
import EBulletinContent from "./EBulletinContent";

const EBulletinPage = ({ isAdmin }) => {
  // State to manage dynamic menu items and loading state
  const [dynamicMenuItems, setDynamicMenuItems] = useState([]);

  const dispatch = useDispatch();

  const { ebullCurrentTab, bulletins } = useSelector(
    (state) => state.generalSlice
  );

  useEffect(() => {
    const list = Array.isArray(bulletins) ? bulletins : [];
    const items = list.map((b) => ({
      key: b.id,
      icon: <FileTextOutlined />,
      label: <span className="hidden md:inline">{b.title}</span>,
    }));
    setDynamicMenuItems(items);

    if (ebullCurrentTab == null) {
      dispatch(setEbullTab(items[0].key));
    }
  }, [ebullCurrentTab]);

  return (
    <>
      <TabBody
        menuItems={dynamicMenuItems}
        currentTabKey="ebullCurrentTab"
        setTabAction={setEbullTab}
        component={<EBulletinContent isAdmin={isAdmin} />}
      />
    </>
  );
};

export default EBulletinPage;
